import { useFloating, autoUpdate, offset } from "@floating-ui/react";
import { useRef, useState } from "react";

type Props = {
	id: number;
	step: number;
	defaultValue?: number[];
	onValueChange?(value: number[]): void;
};
export default function useRange(props: Props) {
	const { id, step, defaultValue, onValueChange } = props;
	const [internalValue, setInternalValue] = useState<number[]>(
		defaultValue || [],
	);
	const [isShowValue, setShowValue] = useState<boolean>(false);
	const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);
	const handleValueChange = (newValue: number[]) => {
		setInternalValue(newValue);
		if (onValueChange) {
			onValueChange(newValue);
		}
		onAction(id, _showCurrentValue);
	};
	// パーツ移動値を表示する
	const _showCurrentValue = () => {
		setShowValue(true);
		// 前のタイマーをクリアする
		if (timeoutId.current) {
			clearTimeout(timeoutId.current);
		}
		// 新しいタイマーを設定する（0.5秒後に非表示）
		timeoutId.current = setTimeout(() => {
			setShowValue(false);
		}, 500);
	};
	const { refs, x, y, strategy } = useFloating({
		placement: "top",
		middleware: [offset(4)],
		whileElementsMounted: autoUpdate,
	});
	const incrementValue = () => {
		if (internalValue[0] !== 100) {
			setInternalValue((prev) => [prev[0] + step]);
			if (onValueChange) {
				onValueChange(internalValue);
			}
		}
		onAction(id, _showCurrentValue);
	};
	const decrementValue = () => {
		if (internalValue[0] !== 1) {
			setInternalValue((prev) => [prev[0] - step]);
			if (onValueChange) {
				onValueChange(internalValue);
			}
		}
		onAction(id, _showCurrentValue);
	};
	// パーツ移動値を表示するメソッドをコンポーネント間で区別するため定義
	const onAction = (id: number, _showCurrentValue: () => void) => {
		_showCurrentValue();
	};

	return {
		isShowValue,
		setInternalValue,
		internalValue,
		refs,
		x,
		y,
		strategy,
		handleValueChange,
		incrementValue,
		decrementValue,
	};
}
